import { ImageDisplay } from '@/components/atoms/ImageDisplay'
import { RcTrans } from '@/components/atoms/RcTrans'
import { MarkdownDisplay } from '@/components/molecules/input/MarkdownDisplay'
import { ChatMessage } from '@/entity/chat/useChatMessages'
import { REACTIONS } from './REACTIONS'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useRcTranslation } from '@/core/hooks/useRcTranslation'

export const ChatMessageText = ({
  message,
  isEdited,
  textOnly,
  tagSelf
}: {
  message?: ChatMessage
  isEdited?: boolean
  textOnly?: boolean
  tagSelf?: boolean
}) => {
  const { t } = useRcTranslation()
  if (message?.unsent) return <RcTrans i18nKey='shared.chat-message-deleted' />

  const isTemp = message?.uid === 'temp'
  const markdown = tagSelf
    ? `${t('shared.chat-message-tag-self')}: ${message?.text}`
    : message?.text

  return (
    <Box>
      <MarkdownDisplay
        markdown={markdown}
        paragraph={false}
        textOnly={textOnly}
        typographyProps={{
          variant: 'subtitle2',
          color: isTemp ? 'text.secondary' : 'text.primary'
        }}
      />
      {isEdited ? (
        <Typography variant='caption' color='text.secondary'>
          <RcTrans i18nKey='shared.chat-message-edited' />
        </Typography>
      ) : null}
    </Box>
  )
}

export const RenderReaction = ({
  id,
  size = 20
}: {
  id: string
  size?: number
}) => {
  const removed = id.replace(/:/g, '')
  const match = REACTIONS.find(it => it.id === removed)
  if (!match) return null
  return (
    <ImageDisplay alt={id} path={match.display} height={size} width={size} />
  )
}
